import Product from "@components/ProductCard/Product";
import { Spinner } from "@components/Spinner";
import styles from "./styles/results.module.css";

export function Results({ products, isLoading, collection, colour }) {
  if (isLoading) {
    return (
      <div className={styles.spinner}>
        <Spinner />
      </div>
    );
  }

  return (
    <div className={styles.container}>
      {products &&
        products.map((item, index) => (
          <Product 
            key={item.id} 
            product={item} 
            collection={collection} 
            listPosition={index} 
            colour={colour}
            openBlank={true}
            fromSearchView={true}
          />
        ))}
    </div>
  );
}
